import { Injectable } from '@angular/core';

@Injectable()
export class AppOfflineStore {
    public dataStore: any = [
        { Language: ['ENG','MAL','HIN'] },
    ];
    public userlanuage:string='ENG';
    public usersrole: number = 0;

    public MotherTongueLanguage:string='MAL';
} 


